import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Checkbox from "@material-ui/core/Checkbox";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";
import {
  updateContractTypeClausesFormat,
  getClausesByContractTypeFormat,
} from "../../actions/contract-type-actions";
import { getAllClauses } from "../../actions/clauses-actions";
import { useStateValue } from "../../context/store";
import { listClauses } from "./models";
import ContractTypeForm from "../../pages/contracts/contractType/contractTypeForm";
import { FormHelperText } from "@material-ui/core";
import utils from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.1)`,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BAE5F9",
      outline: `1px solid #ffffff`,
      borderRadius: 10,
    },
  },
}));

const DialogClauses = ({
  handleClose,
  open,
  handleSave,
  contractTypeId,
  checkAll,
  setCheckAll,
}) => {
  const classes = useStyles();
  const [{ breadCrumb }, dispatch] = useStateValue();

  const [listClausesState, setListClausesState] = useState([]);

  const [listDialogClauses, setListDialogClauses] = useState([]);
  const [clauses, setClauses] = useState([]);
  const [error, setError] = useState(false);
  const [clausesContractType, setClausesContractType] = useState([]);
  var clausesLocal = [];
  var clausesContractTypeLocal = [];

  useEffect(() => {
    getClausesList();
  }, []);

  const getClausesList = async () => {
    const response = await getAllClauses(
      {
        page: 0,
        size: 100,
        order: "DESC",
        columnOrder: "name",
      },
      dispatch
    );
    setClauses(response.data.content);
    clausesLocal = response.data.content;
    getClauses();
  };

  const getClauses = async () => {
    const clauses = await getClausesByContractTypeFormat(
      contractTypeId,
      dispatch
    );
    setClausesContractType(clauses.data.clauses);
    clausesContractTypeLocal = clauses.data.clauses;
    setTest();
  };

  const setTest = () => {
    let previousClauses = clausesLocal;
    let previousclausesByContractType = clausesContractTypeLocal;

    const dataDialog = previousClauses.map((clause) => {
      let tipoContrato = null;
      let isChecked = null;
      const test = previousclausesByContractType?.find(
        (name) => name.id === clause.id
      );
      if (test) {
        tipoContrato = true;
        isChecked = true;
      }
      return { ...clause, tipoContrato: tipoContrato, isChecked: isChecked };
    });

    setListDialogClauses(dataDialog);
    setListClausesState(dataDialog);
    const isTrue = dataDialog.every((obj) => obj.isChecked === true);
    setTimeout(() => {
      setCheckAll(isTrue);
    }, 100);
  };

  const onChangeClause = (e, id) => {
    e.preventDefault();
    const { checked } = e.target;
    let previouslistClausesState = [...listDialogClauses];
    let index = previouslistClausesState.findIndex((x) => x.id === id);
    let item = previouslistClausesState.find((x) => x.id === id);
    item.tipoContrato = checked;
    item.isChecked = checked;

    previouslistClausesState[index] = item;
    setListClausesState(previouslistClausesState);
  };

  const onChangeAllClause = (e) => {
    e.preventDefault();
    const { checked } = e.target;
    setCheckAll(checked);
    let previousClauses = [...listDialogClauses];

    previousClauses.forEach((clause) => {
      let index = previousClauses.findIndex((x) => x.id === clause.id);
      let item = previousClauses.find((x) => x.id === clause.id);
      item.tipoContrato = checked;
      item.isChecked = checked;
      previousClauses[index] = item;
    });

    setListDialogClauses(previousClauses);
    setListClausesState(previousClauses);
  };

  const onSaveLocal = () => {
    const found = listClausesState.find((element) => element.isChecked);
    if (found) {
      handleSave(listClausesState);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 16, padding: 30 },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ color: "#7EBDCE" }}>
          <span>
            <Checkbox
              style={{ marginLeft: "23px", marginRight: "100px" }}
              defaultChecked={checkAll}
              color="primary"
              name={`checkBox`}
              inputProps={{ "aria-label": "secondary checkbox" }}
              checked={checkAll}
              onChange={(event) => onChangeAllClause(event)}
            />
            Agregar cláusula
          </span>
        </DialogTitle>
        <FormHelperText style={{ color: "#f44336", padding: "10px" }}>
          {error && "Debe seleccionar al menos una cláusula"}
        </FormHelperText>
        <Divider style={{ background: "#7EBDCE" }} variant="middle" />
        <div
          style={{ maxHeight: "200", overflow: "auto" }}
          className={classes.root}
        >
          {listDialogClauses.map((modelo) => (
            <Grid container>
              <Grid
                item
                xs={2}
                style={{ textAlign: "end", paddingTop: "12px" }}
              >
                <Checkbox
                  defaultChecked={modelo.isChecked}
                  color="primary"
                  name={`checkBox${modelo.id}`}
                  inputProps={{ "aria-label": "secondary checkbox" }}
                  checked={modelo.isChecked}
                  onChange={(event) => onChangeClause(event, modelo.id)}
                />
              </Grid>
              <Grid item xs={10}>
                <DialogContent key={modelo.id}>
                  <DialogContentText id="alert-dialog-description">
                    {modelo.name}
                  </DialogContentText>
                  <DialogContentText id="alert-dialog-description">
                    {utils.replaceTextDynamicClauses(modelo.definitionClause)}
                  </DialogContentText>
                </DialogContent>
              </Grid>
            </Grid>
          ))}
        </div>
        <DialogActions style={{ justifyContent: "space-around" }}>
          <Button
            onClick={handleClose}
            color="primary"
            variant="outlined"
            style={{ color: "#7EBDCE", borderColor: "#E1E1E1" }}
          >
            Cancelar
          </Button>
          <Button
            onClick={onSaveLocal}
            color="primary"
            autoFocus
            style={{ backgroundColor: "#7EBDCE", color: "#ffffff" }}
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default DialogClauses;
